import { getUserInfo, setUserInfo } from '@/utils/storage'

export default {
  namespaced: true,
  state () {
    return {
      userInfo: getUserInfo()
    }
  },
  mutations: {
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
      setUserInfo(userInfo)
    }
  },
  actions: {
    logout (context) {
      context.commit('setUserInfo', {})

      // 跨模块访问 => 传入第三个参数 { root: true }
      context.commit('cart/setCartList', [], { root: true })
    }
  },
  getters: {}
}
